 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP271583 from '@/components/chap271583'
 import CHAP271577 from '@/components/chap271577'
 import CHAP271576 from '@/components/chap271576'
 import CHAP271575 from '@/components/chap271575'
 import CHAP271579 from '@/components/chap271579'
 import CHAP271578 from '@/components/chap271578'
 import CHAP271586 from '@/components/chap271586'
 import CHAP271584 from '@/components/chap271584'
 import CHAP271581 from '@/components/chap271581'
 import CHAP271574 from '@/components/chap271574'
 import LOVE_2 from '@/components/love_2'
 import CHAP271582 from '@/components/chap271582'
 import CHAP271580 from '@/components/chap271580'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap271583",
 			"name" : "chap271583",
 			"component" : CHAP271583
 		},
 		{
 			"path" : "/chap271577",
 			"name" : "chap271577",
 			"component" : CHAP271577
 		},
 		{
 			"path" : "/chap271576",
 			"name" : "chap271576",
 			"component" : CHAP271576
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js